export default class UtilSequence {

    static async each({ list = [], callback }) {
        
        const accumulator = [];
        let index = 0;

        for await (const item of list) {
            const response = await callback(item,index);
            if(response){
                accumulator.push(response);
                index++;
            }
        }

        return accumulator;
    }

}
